import axios from 'axios';
import notify from '@/utils/notify'

axios.defaults.withCredentials = true;
/* axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    logout(error)
    return Promise.reject(error);
}); */
let cred = window.location.toString().split("?")[1];
if (cred && window.location.toString().indexOf("token=") > 0) {
    let token = cred.split("=")[1];
    if (token.length > 100) {
        localStorage.setItem("token", cred.split("=")[1]);
    }
}
const token = localStorage.getItem('token')
var headers = {}

if (token) {
    headers = {
        headers: {
            'Authorization': `Bearer ${token}`,
        }
    }
}

const http = {
    get: (url) => axios.get(url, headers),
    post: (url, param, header = null) => {
        return axios.post(url, param, { header, ...headers });
    },
    put: (url, param) => {
        return axios.put(url, param, headers);
    },
    delete: (url, param) => {
        return axios.delete(url, { params: param }, headers);
    },
    del: (url) => {
        return axios.delete(url, headers);
    }
}

const clear = (data) => {
    if (typeof data === 'object')
        Object.keys(data).map(attr => data[attr] === "" && delete data[attr]);

    return data
}

const api = (url, data, commit) => {
    if (data && typeof data === 'object')
        Object.keys(data).map(attr => data[attr] === "" && delete data[attr]);

    return http[url.type](url.url + ((url.type == 'get' || url.type == 'delete') && data && (typeof data == "string" || !isNaN(data)) ? data : '') +
        (data.params ? data.params : ''), data).then(r => {
            if (r.data && r.data.msg) commit('general/SET_STATUS', { text: r.data.msg, color: 'green' }, { root: true })
            return r
        }).catch((e) => {
            notify(commit, e);
            // if (e.response.data && e.response.data.msg) commit('general/SET_STATUS', { text: e.response.data.msg, color: 'red' }, { root: true })
            return e.response
        })
}

export { http as default, api, clear }